'use strict';var _desc,_value,_class;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseUserProfileController=require('./baseUserProfileController');
const LoginModalConfig=require('../../../../../../dist-es6/client/features/login/modals/loginModalConfig');
const HandleUncaughtErrors=require('../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;let

UserProfileDirective=function(_BaseControllerBacked){_inherits(UserProfileDirective,_BaseControllerBacked);function UserProfileDirective(){_classCallCheck(this,UserProfileDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(UserProfileDirective,[{key:'templateUrl',get:function()
{
return'/templates/features/profile/components/userProfile/userProfileView';
}},{key:'controller',get:function()

{
return UserProfileController;
}}]);return UserProfileDirective}(BaseControllerBackedDirective);let


UserProfileController=(_class=function(_BaseUserProfileContr){_inherits(UserProfileController,_BaseUserProfileContr);_createClass(UserProfileController,null,[{key:'$inject',get:function()
{
return['$timeout','$modal','userService','uncaughtErrorHandler'];
}}]);

function UserProfileController($timeout,$modal,userService,uncaughtErrorHandler){_classCallCheck(this,UserProfileController);var _this2=_possibleConstructorReturn(this,
_BaseUserProfileContr.call(this,uncaughtErrorHandler,userService.currentUser));
_this2._$timeout=$timeout;
_this2._$modal=$modal;
_this2._userService=userService;

_this2._forceReloadOfUserInfo();return _this2;
}UserProfileController.prototype.


_forceReloadOfUserInfo=function(){var ref=_asyncToGenerator(function*(){
yield this._userService.continueUserSession();
this._reloadInfoFromUserService();
});function _forceReloadOfUserInfo(){return ref.apply(this,arguments)}return _forceReloadOfUserInfo}();UserProfileController.prototype.

_reloadInfoFromUserService=function _reloadInfoFromUserService(){var _this3=this;
this._$timeout(function(){

if(_.exists(_this3._userService.currentUser)){
_this3._firstName=_this3._userService.currentUser.firstName;
_this3._lastName=_this3._userService.currentUser.lastName;
_this3._phone=_this3._userService.currentUser.phone;
_this3._email=_this3._userService.currentUser.email;
}
});
};UserProfileController.prototype.

editUser=function editUser(){var _this4=this;
let modalInstance=this._$modal.open({
templateUrl:'/templates/features/profile/components/userProfile/editUserModalView',
controller:'EditUserModalController as controller',
resolve:{
user:function(){return _this4},
onUserUpdated:function(){return _this4._reloadInfoFromUserService.bind(_this4)}}});


};UserProfileController.prototype.

changePassword=function changePassword(){var _this5=this;
let changePasswordModalInstance=this._$modal.open({
templateUrl:'/templates/features/profile/components/userProfile/changeUserPasswordModalView',
controller:'ChangeUserPasswordModalController as controller'});

changePasswordModalInstance.result.then(function(){
let modalConfigWithPasswordChangedText=_.defaultsDeep({resolve:{reason:function(){return'PasswordChanged'}}},LoginModalConfig);
let loginModalInstance=_this5._$modal.open(modalConfigWithPasswordChangedText);
});
};return UserProfileController}(BaseUserProfileController),(_applyDecoratedDescriptor(_class.prototype,'_forceReloadOfUserInfo',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_forceReloadOfUserInfo'),_class.prototype)),_class);


module.exports=UserProfileDirective;
//# sourceMappingURL=userProfileDirective.js.map
